
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsShopGroupGrid extends Serenity.EntityGrid<PsShopGroupRow, any> {
        protected getColumnsKey() { return PsShopGroupColumns.columnsKey; }
        protected getDialogType() { return PsShopGroupDialog; }
        protected getIdProperty() { return PsShopGroupRow.idProperty; }
        protected getInsertPermission() { return PsShopGroupRow.insertPermission; }
        protected getLocalTextPrefix() { return PsShopGroupRow.localTextPrefix; }
        protected getService() { return PsShopGroupService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}